import React from 'react';
import Link from 'next/link';
import { useTranslations } from '../../locales/useTranslations';

const ManagedServicesCta = () => {
  const { t } = useTranslations();

  return (
    <section className="ms-cta ms-cta--enhanced">
      <div className="ms-cta__glow ms-cta__glow--1" aria-hidden />
      <div className="ms-cta__glow ms-cta__glow--2" aria-hidden />
      <div className="container ms-cta__inner">
        <span className="ms-cta__badge">{t('managedServices_cta_badge')}</span>
        <h2 className="ms-cta__title">{t('managedServices_cta_title')}</h2>
        <p className="ms-cta__text">{t('managedServices_cta_description')}</p>
        <div className="ms-cta__actions">
          <Link href="/kontakt/" className="ms-header__btn-primary">
            {t('managedServices_cta_button')}
          </Link>
          <Link href="/managed-services/zerotrustvpn/" className="ms-header__btn-secondary">
            {t('managedServices_header_cta_secondary')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ManagedServicesCta;
